import { ComponentProps } from "react";
import styled from "@emotion/styled";
import { UserIcon } from "@heroicons/react/24/solid";
import { Icon } from "@unlikelyai-magic/ui/icons";

type ChatAvatarProps = ComponentProps<"div"> & {
  visible?: boolean;
};

export const UserAvatar = styled(({ visible, ...props }: ChatAvatarProps) => (
  <div {...props}>
    <Icon icon={UserIcon} size="1.25rem" />
  </div>
))`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.colors.component.border[1]};
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
  padding-top: 0.125rem;
`;
